import { useQuery } from '@tanstack/react-query';
import { getDasPolicyDetails } from '../../../services/das.service';

export const useDasPolicyDetails = (policyNumber, enabled = false) => {
  return useQuery({
    queryKey: ['dasPolicyDetails', policyNumber || 'none'],
    queryFn: () => getDasPolicyDetails(policyNumber),
    enabled: !!enabled && !!policyNumber,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
    onError: (error) => {
      console.error('Error fetching DAS policy details:', error);
    }
  });
};
